import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import Logo from '../../ui/Logo';
import LangSelector from '../../components/LangSelector';
import { NavLink, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import OfflineModeIndicator from '../../components/OfflineModeIndicator';
import Button from '../../ui/Button';
import { useAppDispatch } from '../../store';
import { logout, selectIsAuthenticated } from '../../store/adminSlices/auth';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const PageHeader = ({ logoSize, title, countDownTimer, logoLink, container = 'container', }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const isAdminPanel = container === 'admin-container';
    const handleLogout = () => {
        dispatch(logout());
        navigate(APP_ROUTES.adminLogin);
    };
    return (_jsx("header", { className: "page-header", children: _jsx("div", { className: container, children: _jsxs("div", { className: "header-content-wrapper", children: [_jsxs("div", { className: "header-content-row row--top screenshot-content", children: [_jsx(NavLink, { to: logoLink, children: _jsx(Logo, { size: logoSize }) }), title] }), _jsxs("div", { className: "header-content-row row--bottom", children: [_jsx(OfflineModeIndicator, {}), countDownTimer, _jsx(LangSelector, {}), isAdminPanel && isAuthenticated && (_jsx(Button, { onClick: handleLogout, label: t('button.logout'), variant: 'text' }))] })] }) }) }));
};
export default PageHeader;
